
import { toast } from "@/hooks/use-toast";

// For security purposes, we'll let users input their own API key temporarily
let openAIApiKey = '';

export const setApiKey = (key: string) => {
  openAIApiKey = key;
  localStorage.setItem('openai_api_key', key);
  return true;
};

export const getApiKey = () => {
  if (!openAIApiKey) {
    // Try to get from localStorage
    const storedKey = localStorage.getItem('openai_api_key');
    if (storedKey) {
      openAIApiKey = storedKey;
    }
  }
  return openAIApiKey;
};

export const sendMessageToOpenAI = async (messages: { role: 'user' | 'assistant' | 'system', content: string }[]) => {
  const apiKey = getApiKey();
  
  if (!apiKey) {
    throw new Error('API key not set');
  }

  try {
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages,
        max_tokens: 500,
        temperature: 0.7
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error?.message || 'Failed to get response from OpenAI');
    }

    const data = await response.json();
    return data.choices[0].message.content;
  } catch (error) {
    console.error('Error calling OpenAI:', error);
    toast({
      title: "Error",
      description: error instanceof Error ? error.message : "Failed to get AI response",
      variant: "destructive"
    });
    throw error;
  }
};
